const ConversationalIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2305 19.2989H18.7617C20.3535 19.2989 21.6485 18.0039 21.6485 16.4121V12.6465C21.6485 11.0547 20.3535 9.75977 18.7617 9.75977H11.2305C9.63873 9.75977 8.34375 11.0547 8.34375 12.6465V16.4121C8.34381 18.0039 9.63873 19.2989 11.2305 19.2989ZM16.2574 14.3785L17.1988 13.4371C17.5262 13.0967 18.1146 13.0967 18.4418 13.4371L19.3832 14.3785C19.7264 14.7218 19.7264 15.2782 19.3832 15.6215C19.0398 15.9648 18.4833 15.9646 18.1402 15.6215L17.8203 15.3016L17.5003 15.6215C17.1571 15.9646 16.6006 15.9647 16.2574 15.6215C15.9142 15.2783 15.9142 14.7218 16.2574 14.3785ZM10.609 14.3786L11.5504 13.4372C11.8777 13.0967 12.4661 13.0967 12.7934 13.4372L13.7347 14.3786C14.078 14.7218 14.078 15.2783 13.7347 15.6215C13.3914 15.9648 12.8349 15.9647 12.4918 15.6215L12.1719 15.3016L11.8519 15.6215C11.5087 15.9648 10.9522 15.9648 10.609 15.6215C10.2658 15.2783 10.2658 14.7218 10.609 14.3786Z"
      fill="white"
    />
    <path
      d="M14.1197 6.79131V8.00191H15.8775V6.79131C18.8003 5.75982 18.1359 1.47369 14.9985 1.41211C11.8607 1.47398 11.1973 5.76035 14.1197 6.79131Z"
      fill="white"
    />
    <path
      d="M12.8011 23.3219L13.0144 23.5352H16.9934L17.2067 23.3219C17.3714 23.1571 17.595 23.0644 17.8281 23.0644H27.1797V12.6465C27.1797 11.102 25.9251 9.88477 24.418 9.88477H22.5012C23.0744 10.6573 23.4141 11.6129 23.4141 12.6465V16.4121C23.4141 18.9731 21.3306 21.0567 18.7696 21.0567H11.2383C8.67725 21.0567 6.59371 18.9731 6.59371 16.4121V12.6465C6.59371 11.6128 6.93344 10.6572 7.50666 9.88477H5.58982C4.07113 9.88477 2.82812 11.1126 2.82812 12.6465V23.0644H12.1797C12.4128 23.0644 12.6364 23.1571 12.8011 23.3219Z"
      fill="white"
    />
    <path
      d="M29.1211 24.8223H18.1883L17.975 25.0355C17.8102 25.2004 17.5866 25.293 17.3535 25.293H12.6465C12.4133 25.293 12.1898 25.2004 12.025 25.0355L11.8117 24.8223H0.878906C0.393516 24.8223 0 25.2158 0 25.7012V25.8262C0 27.3694 1.25332 28.5879 2.76176 28.5879H27.2382C28.7815 28.5879 30 27.3346 30 25.8262V25.7012C30 25.2158 29.6065 24.8223 29.1211 24.8223Z"
      fill="white"
    />
  </svg>
)

export default ConversationalIcon
